import {Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {SharingRulesGroup} from './api/entity/sharing-rules-group.model';
import {TranslateManager} from '../../../../common/translate';
import {ExceptionTypeService} from './exception-type.service';
import {Subscription} from 'rxjs/Subscription';
import {Share} from './api/entity/share.model';
import {ControlContainer, NgForm} from '@angular/forms';
import {LeaveBlockable} from '../../shared/leave-block';
import {BENEFICIARY_KIND} from './api/entity/beneficiary-kind.model';
import {DictionaryObject} from '../../../../common/api';
import {Item} from "../dropdown/dropdown.component";

@Component({
    selector: 'tfl-profile-detail-settings-revenue',
    template: require('./profile.settings.revenue.component.html'),
    viewProviders: [ { provide: ControlContainer, useExisting: NgForm } ]
})
export class ProfileSettingsRevenueComponent implements OnInit, OnDestroy {
    @Input() loading: boolean = false;
    @Input() defaultRulesGroup: SharingRulesGroup;
    @Input() exceptionsRulesGroup: SharingRulesGroup[];
    @Input() availableFeeServices: DictionaryObject[] = [];
    @Input() exceptionTypes: Item[] = [];
    @Input() profileId: number;
    @Input('form') ngForm: NgForm;
    @Input() availableProfileKinds: DictionaryObject[] = [];
    @Input() availableProfiles: DictionaryObject[] = [];

    @Output('customChange') customChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    private changeConditionListener: Subscription;

    constructor(private _translateManager: TranslateManager,
                private _exceptionTypeService: ExceptionTypeService,
                @Inject('LeaveBlockable') private _leaveGuard: LeaveBlockable) {
    }

    ngOnInit(): void {
        this.ngForm.valueChanges.subscribe(() => {
            this._leaveGuard.setComponentAllowedToLeave(this._leaveGuard.isComponentAllowedToLeave() && this.ngForm.pristine);
        });
        this.changeConditionListener = this._exceptionTypeService.observeAvailabilityChanges().subscribe(availability => {
            this.exceptionTypes && this.exceptionTypes.forEach(type => {
                if (type.id === availability.id) {
                    type.disabled = !availability.available;
                }
            })
        });
    }

    onChange(): void {
        this.customChange.emit();
    }

    ngOnDestroy(): void {
        this.changeConditionListener.unsubscribe();
    }

    onExceptionTypeSelected(it) {
        this.exceptionsRulesGroup.unshift(this.createExceptionModel(it.id));
        this.ngForm.form.markAsDirty();
    }

    private createExceptionModel(exceptionType): SharingRulesGroup {
        return {
            id: null,
            availableBeneficiaryKinds: this.defaultRulesGroup.availableBeneficiaryKinds,
            conditions: {
                type: exceptionType,
                profiles: [],
                profileKinds: []
            },
            name: 'New Exception',
            rules: [{
                fee: {
                    id: undefined,
                    name: 'All services',
                },
                mandatory: false,
                shares: this.populateShares(this.defaultRulesGroup.rules[0].shares)
            }]
        }
    }

    private populateShares(template: Share[]): Share[] {
        return template.map(t => ({
            percent: t.beneficiaryKind === BENEFICIARY_KIND.SYSTEM ? 100 : 0,
            beneficiaryKind: t.beneficiaryKind,
            beneficiaryKindId: t.beneficiaryKindId
        }))
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/revenue/profile.settings.revenue.component.ts